import { AxiosResponse } from "axios";
import { api } from "../library/axios";
import { API_ROUTE } from "../const/apiRoute";
import { HanderResponse } from "../_base/helper/FunctionHelper";
import {
  AddMenuToGroup,
  AddUserToGroup,
  CreateMenuGroup,
} from "../model/MenuGroup";
import { repositoryMaster } from "../_base/_const/_constVar";
import { MessageResponse } from "../model/MessageResponse";
import { SelectListItemBase } from "../_base/model/_base/SelectListItemBase";
import {
  AddAuthAndAddUser,
  AddGroupAPI,
  AddUserAuthAPI,
} from "../model/GroupAPI";

export const getListMenuGroup = async (query: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_LIST_MENU_GROUP + query
    );
    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createMenuGroup = async (
  dataSubmit: CreateMenuGroup
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.CREATE_MENU_GROUP,
      dataSubmit
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const editMenuGroup = async (
  dataSubmit: CreateMenuGroup
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.EDIT_MENU_GROUP,
      dataSubmit
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteMenuGroup = async (ids: string[]): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_MENU_GROUP,
      { ids: ids }
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const addMenuToGroup = async (
  dataSubmit: AddMenuToGroup[]
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.ADD_MENU_GROUP,
      dataSubmit
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const addUserToGroup = async (
  dataSubmit: AddUserToGroup[]
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.ADD_USER_GROUP,
      dataSubmit
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataMenuByGroup = async (params: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_MENU_BY_GROUP + `?GroupId=${params}`
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getDataUserByGroup = async (params: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.GET_USER_BY_GROUP + `?GroupId=${params}`
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getMenuByEmp = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_MENU_BY_EMP +
        `?empId=${JSON.parse(localStorage.getItem("userData") || "{}")?.empId}`
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getGroupAPIList = async (params: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GET_GROUP_API_LIST + params
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const createGroupAddAPI = async (
  dataSubmit: AddGroupAPI
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.GROUP_API_ADD,
      dataSubmit
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const editGroupAddAPI = async (
  dataSubmit: AddGroupAPI
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.GROUP_API_EDIT,
      dataSubmit
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const deleteGroupAPI = async (ids: string[]): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.DELETE_GROUP_API,
      ids
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const groupAPIAddAuth = async (
  dataSubmit: AddAuthAndAddUser
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.GROUP_API_ADD_AUTH,
      dataSubmit
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getAuthToGroup = async (params: string): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GROUP_API_AUTH_GET + `?GroupId=${params}`
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const groupAPIUserAdd = async (
  dataSubmit: AddUserAuthAPI
): Promise<any> => {
  try {
    const response: AxiosResponse = await api.post(
      API_ROUTE.GROUP_API_ADD_USER,
      dataSubmit
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getUserAuthByGroup = async (params: any): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(
      API_ROUTE.GROUP_API_USER_GET + `?GroupId=${params}`
    );

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export const getAuthKey = async (): Promise<any> => {
  try {
    const response: AxiosResponse = await api.get(API_ROUTE.GET_AUTH_KEY);

    return response.data;
  } catch (error) {
    HanderResponse(error);
  }
};

export async function getUserAll() {
  const url = "/auth/get-select";
  const callapi = await repositoryMaster.get<
    MessageResponse<SelectListItemBase[]>
  >(url);
  if (callapi?.success) return callapi?.data;
  return [];
}
